import Link from 'next/link';
import { useAuthentication } from '@context/businessContainer';
import { ReactElement } from 'react';
import GiftItemBanner from '@components/GiftItemBanner';
import SideShoppingCart from '@components/Layout/Header/SideShoppingCart';
import { useShoppingCart } from '@hooks/cart/useShoppingCart';
import { Logo } from '@components/Logo';

interface ILayoutNoCTAProps {
  displayGiftBanner?: boolean;
  children?: ReactElement<any>;
  withCart?: boolean;
}

const LayoutNoCTA: React.FC<ILayoutNoCTAProps> = ({
  children,
  withCart = false,
}) => {
  const { isAuthenticated } = useAuthentication();
  const { shoppingCart } = useShoppingCart();
  const { totalQuantity = 0 } = shoppingCart;

  const hasOnlyGiftItem = Boolean(
    shoppingCart.hasGiftItem && shoppingCart.products.length === 1,
  );
  const showCart = withCart && totalQuantity > 0 && !hasOnlyGiftItem;

  const displayGiftBanner =
    typeof children?.props === 'object' &&
    children?.props != null &&
    'displayGiftBanner' in children.props &&
    typeof children.props.displayGiftBanner === 'boolean'
      ? children.props.displayGiftBanner
      : false;

  return (
    <>
      <header className="main-header">
        {displayGiftBanner ? <GiftItemBanner /> : null}
        <div className="logo">
          <Link href={isAuthenticated ? '/home' : '/'} legacyBehavior>
            <a data-testid="LayoutNoCTA-go-to-home">
              <Logo />
            </a>
          </Link>
        </div>
        {showCart && (
          <div className="cart">
            <SideShoppingCart />
          </div>
        )}
      </header>
      <main>{children}</main>
      <style jsx>{`
        header {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: var(--white);
        }

        .logo {
          max-width: 120px;
          width: 100%;
          max-height: 55px;
          margin: var(--space-4);
        }

        .logo a {
          display: block;
        }
        .cart {
          position: absolute;
          right: 0;
          bottom: var(--space-6);
          padding: var(--padding-layout-base);
        }
      `}</style>
    </>
  );
};

export default LayoutNoCTA;
